import React, { Component } from 'react';
import { connect } from 'react-redux';

import Swal from 'sweetalert2';

import Button from 'Flow2/components/UI/Button/Button';

import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import TagsTree from 'Flow2/components/TagsTree/TagsTree';

import classes from './Masterdata.module.scss';
import * as actions from 'store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import StructureMapping from 'Flow2/util/StructureMapping.js';
import MetadataLanguage from 'Flow2/util/MetadataLanguage.js';
import MetadataElementHelper from 'Flow2/util/MetadataElementHelper.js';
import MetadataPermissionHelper from 'Flow2/util/MetadataPermissionHelper.js';

import { IntlProvider, FormattedMessage, addLocaleData } from 'react-intl';
import locale_en from 'react-intl/locale-data/en';
import locale_de from 'react-intl/locale-data/de';
import deTranslation from "PMDB/assets/languages/de.json";
import enTranslation from "PMDB/assets/languages/en.json";

import { de } from 'date-fns/locale/de';
import { format, isValid } from 'date-fns';
import Spinner from 'Flow2/components/UI/Spinner/Spinner';
import { isTranscoder1 } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
//registerLocale('de', de);


export const OBJECT_TYPE_CLIP = 'clip';
export const OBJECT_TYPE_ROOM = 'room';
export const OBJECT_TYPE_PROJECT = 'project';
export const OBJECT_TYPE_DISTRIBUTION = 'distribution';
export const OBJECT_TYPE_MEDIAFILE = 'mediafile';

const METADATA_MODE_TEXT = 'text';
const METADATA_MODE_EDIT = 'edit';
const METADATA_MODE_CANCEL = 'cancel';

class Metadata extends Component {

    structures = {}
    checkbox = {}    // internal structure to handle checkbox values

    defaults = {
        datefield: "0000-00-00",
        checkbox: "0",
        state: {
            updated: false,
            mode: METADATA_MODE_TEXT   // text for display, edit for editable
        }
    }

    constructor(props) {
        super(props);
        //console.log(props);
        this.languageHelper = new MetadataLanguage(this.props.config.languages, this.props.config.defaultLanguage);
        this.state = { ...this.defaults.state, ...this.initState(props) }
        this.structures = { ...this.initInternalStructures(props) };
        MetadataPermissionHelper.hasDeletePermission(props);
    }

    initState = (props) => {
        const state = {};

        state.tabs = props.tabs || [];
        state.lang = this.languageHelper.getInitialLang(props.appLang);
        state.elements = StructureMapping.getUsedElements(props.type, props.data, state.tabs);

        return state;
    }

    initInternalStructures = (props) => {
        const structures = {};

        structures.tabs = StructureMapping.createTabStructure(props.type);
        structures.lang = StructureMapping.createLangStructure(props.type, props.config.languages);
        structures.checkbox = StructureMapping.createCheckboxStructure(props.type, props.data);
        structures.remove = StructureMapping.createRemoveStructure(props.type, props.data);

        return structures;
    }

    componentDidMount = () => {
        this.props.loadUsers();
    }

    getValue = (field) => {
        if (field && this.state.elements.hasOwnProperty(field)) {
            return this.state.elements[field];
        }
        return "";
    }

    toggleMetadata = () => {
        if (this.props.viewState === 'open') {
            this.props.closed();
        } else {
            this.props.opened();
        }
    }

    toggleMode = (mode) => {
        switch (mode) {
            case METADATA_MODE_TEXT:
                this.setState({ updated: false, mode: METADATA_MODE_EDIT });
                break;
            case METADATA_MODE_EDIT:
                if (this.state.updated) {
                    // remove entries which will not be saved
                    const elements = { ...this.state.elements };
                    this.structures.remove.forEach(item => {
                        if (elements.hasOwnProperty(item)) {
                            delete elements[item];
                        }
                    });

                    this.props.updateMetadata(this.props.type, this.props.id, elements);
                }

                this.setState({ updated: false, mode: METADATA_MODE_TEXT });
                break;
            case METADATA_MODE_CANCEL:
                this.setState({ updated: false, mode: METADATA_MODE_TEXT });
                break;
            default:
                this.setState({ updated: false, mode: METADATA_MODE_TEXT });
                break;
        }
    }

    toggleLang = (lang) => {
        const newLang = this.languageHelper.switchLang(lang);
        this.setState({ lang: newLang });
    }

    createCheckboxStructure = (element, options, values) => {
        this.structures.checkbox[element] = {};
        for (let key in options) {
            if (values.includes(key)) {
                this.structures.checkbox[element][key] = true;
            } else {
                this.structures.checkbox[element][key] = false;
            }
        }
    }

    inputChangedHandler = (value, element) => {
        const ReleasedElement = {
            ...this.state.elements,
            [element]: value.replace(/; /g, ';')
        };

        this.setState({ elements: ReleasedElement, updated: true });
    }

    dateChangedHandler = (date, element) => {
        let dateString = this.defaults.datefield;
        if (date !== null) {
            dateString = format(date, 'YYYY-MM-DD');
        }

        const updatedElement = {
            ...this.state.elements,
            [element]: dateString
        };

        this.setState({ elements: updatedElement, updated: true });
    }

    checkboxChangeHandler = (element, key) => {
        if (!this.structures.checkbox[element]) {
            return;
        }

        this.structures.checkbox[element][key] = !this.structures.checkbox[element][key];
        let value = this.createValueString(element);

        // workaround for single checkboxes with default value 0 if not checked
        if (value === "" && this.structures.checkbox[element] && Object.keys(this.structures.checkbox[element]).length === 1) {
            value = this.defaults.checkbox;
        }

        this.setState(state => {
            state.elements[element] = value
            state.updated = true
            return state
        });
    }

    addListHandler = (input, element) => {
        // TODO: check input email
        // Move this method to elementHelper

        if (input !== '') {
            this.props.addMemberToProject(this.props.id, input);

            input = (this.state.elements[element]) ? input + ';' + this.state.elements[element] : input;

            const ReleasedElement = {
                ...this.state.elements,
                [element]: input
            };

            this.setState({ elements: ReleasedElement, updated: true });
        }
    }

    removeListHandler = (index, element) => {
        // TODO: handle remove
        // Move this method to elementHelper

        let x = this.state.elements[element].split(';');
        this.props.delMemberFromProject(this.props.id, x[index]);
        x.splice(index, 1);
        x = x.join(';');

        const ReleasedElement = {
            ...this.state.elements,
            [element]: x
        }

        this.setState({ elements: ReleasedElement, updated: true });
    }

    // create string from checkbox values to save in backend
    createValueString = (element) => {
        let value = "";
        for (let key in this.structures.checkbox[element]) {
            if (this.structures.checkbox[element][key]) {
                if (value !== "") {
                    value += ";" + key;
                } else {
                    value += key;
                }
            }
        }
        return value;
    }

    tagTreeAddHandler = (values, addedTag) => {
        this.tagTreeChangeHandler(values);
    }

    tagTreeRemoveHandler = (values, removedTag) => {
        this.tagTreeChangeHandler(values);
    }

    tagTreeChangeHandler = (values) => {
        const ReleasedElement = {
            ...this.state.elements,
            ...values
        };

        this.setState({ elements: ReleasedElement, updated: true });
    }

    createMetadata = () => {
        if (this.props.viewState !== 'open') {
            return '';
        }

        let content = [];
        for (let tab in this.state.tabs) {
            const tableElementsArray = this.createElements(this.state.tabs[tab]);

            let section = [];
            section.push(<tr key={this.state.tabs[tab]}><th colSpan="2" className={classes.Section}><FormattedMessage id={this.state.tabs[tab]} /></th></tr>);
            if (tableElementsArray.length === 0) {
                //section.push(<tr key="no_data"><td colSpan="2">Keine Daten</td></tr>);
            } else {
                section = section.concat(tableElementsArray.map((element, i) => (
                    <tr key={element.id + i}>
                        <th><FormattedMessage id={element.intl} defaultMessage={element.name} /></th>
                        <td>{element.field}</td>
                    </tr>
                )));
            }
            content = content.concat(section);
        }

        return (
            <IntlProvider
                key={this.state.lang}
                locale={this.state.lang}
                messages={this.props.config.languages[this.state.lang].messages}
            >

                <FlexColumn className={classes.Container}>
                    <FlexRow className={classes.Header}>
                        {/*<div><FontAwesomeIcon icon="folder" /></div>*/}
                        <div style={{ flex: 1 }}><FormattedMessage id={this.props.title} /></div>
                        {(this.props.id !== 0 && MetadataPermissionHelper.hasPermission(this.props)) ? <Icon mode={this.state.mode} click={() => this.toggleMode(this.state.mode)} cancel={() => this.toggleMode(METADATA_MODE_CANCEL)} /> : ""}
                        <Lang lang={this.state.lang} click={() => this.toggleLang(this.state.lang)} />
                    </FlexRow>
                    <FlexColumn className={classes.Content}>
                        <table>
                            <tbody>
                                {content}
                            </tbody>
                        </table>
                    </FlexColumn>
                </FlexColumn>

            </IntlProvider>
        );
    }

    createElements = (tab) => {
        let elementsArray = [];

        for (let key in this.state.elements) {
            // if (this.showField(tab, key) && this.checkMediaType(key)) {
            if ((!isTranscoder1() && (this.showField(tab, key) && this.checkMediaType(key))) || isTranscoder1()) {
                let element = this.getElement(key);

                if (element && !StructureMapping.isHidden(element.obj)) {
                    elementsArray.push(element);
                }
            }
        }

        return elementsArray.sort(StructureMapping.sortByOrder);
    }

    showField = (tab, field) => {
        if (!tab || !field) {
            return false;
        }

        if (!MetadataPermissionHelper.hasFieldPermission(this.props, field, 'see')) {
            return false;
        }

        if (!this.structures.lang[this.state.lang] || !this.structures.lang[this.state.lang].includes(field)) {
            return false;
        }

        if (this.structures.tabs[tab] && this.structures.tabs[tab].includes(field)) {
            return true;
        }

        return false;
    }

    checkMediaType = (key) => {
        if (this.props.mediaType != "video") {
            if (key === "duration_technical" || key === "eingebrannteuntertitel") {
                return false;
            }
        }

        if (this.props.mediaType != "pictures") {
            if (key === "aufloesung" || key === "format" || key === "bildformat") {
                return false;
            }
        }

        return true;
    }

    getElement = (key) => {
        const element = MetadataElementHelper.createElement(this.props.type, key, this.state.elements[key]);

        if (this.showDisplayField(element, key)) {
            element.field = MetadataElementHelper.createDisplayField(element, this);
        } else {
            element.field = MetadataElementHelper.createEditField(element, this);
        }

        return element;
    }

    showDisplayField = (element, key) => {
        if (this.state.mode === METADATA_MODE_TEXT) return true;
        if (StructureMapping.isReadonly(element.obj)) return true;
        if (!MetadataPermissionHelper.hasFieldPermission(this.props, key, 'edit')) return true;
        return false;
    }

    render = () => {
        let metadata = '';
        let overlay = '';

        if (this.props.viewState === 'open') {
            metadata = this.createMetadata();
        }

        if (this.props.loading) {
            overlay = (
                <div className={classes.Overlay}>
                    <Spinner />
                </div>
            );
        }

        const attachedClasses = [classes.Metadata, classes[this.props.viewState], classes[this.state.mode], "relative"];

        return (
            <FlexColumn className={attachedClasses.join(' ')}>
                {overlay}
                <Toggle open={this.props.open} toggle={this.toggleMetadata} />
                {metadata}
            </FlexColumn>
        );
    }

    componentWillReceiveProps(nextProps) {
        console.log(nextProps.data);
        /*const state = { ...this.state, ...this.defaults.state, ...this.initState(nextProps), lang: this.state.lang }
            this.structures = { ...this.initInternalStructures(nextProps) };
            this.setState({ ...state });*/
        // set only if different type or same type and different id (NAND)
        if (!((nextProps.type === this.props.type) && (nextProps.id === this.props.id))) {
            const state = { ...this.state, ...this.defaults.state, ...this.initState(nextProps), lang: this.state.lang }
            this.structures = { ...this.initInternalStructures(nextProps) };
            this.setState({ ...state });
        }
    }
}

const Toggle = (props) => {
    let attachedClasses = ["pointer"];

    if (props.open) {
        attachedClasses.push(classes.ToggleOpen);
        return (
            <FlexRow className={attachedClasses.join(' ')}>
                <Button
                    btnType="Transparent"
                    clicked={props.toggle}>
                    <FontAwesomeIcon icon="chevron-right" /> <FormattedMessage id="sidebar.minimize" /> <FormattedMessage id="sidebar.metadata" />
                </Button>
            </FlexRow>
        );
    }

    attachedClasses.push(classes.ToggleClosed);
    return (
        <FlexRow className={attachedClasses.join(' ')}>
            <Button
                btnType="Transparent"
                clicked={props.toggle}>
                <FontAwesomeIcon icon="chevron-left" />
            </Button>
        </FlexRow>
    );
}

const Icon = (props) => {
    if (props.mode === METADATA_MODE_TEXT) {
        return <div className="pointer" onClick={props.click}><span className={classes.Btn}><FontAwesomeIcon icon="pen" /></span></div>
    }
    return <div className="pointer" onClick={props.click}><span className={classes.Btn}><FontAwesomeIcon icon="save" /></span></div>;

    // TODO
    // if METADATA_MODE_CANCEL -> reset all changes in the local state ...

    /*
    return (<><div className="pointer" onClick={props.click}>
                <span className={classes.Lang}><FontAwesomeIcon icon="save" /></span>
            </div>
            <div className="pointer" onClick={props.cancel}>
                <span className={classes.Lang}><FontAwesomeIcon icon="window-close" /></span>
            </div></>);
    */
}

const Lang = (props) => {
    return <div className="pointer" onClick={props.click}><span className={classes.Btn}>{props.lang}</span></div>
}

const mapStateToProps = (state) => {
    return {
        viewState: state.ui.metadataState,
        open: state.ui.metadataState === 'open',
        appLang: state.ui.language,
        user: state.auth.user,
        users: state.user.users,
        config: state.ui.config,
        loading: state.metadata.loading
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        opened: () => dispatch(actions.metadataOpened()),
        closed: () => dispatch(actions.metadataClosed()),
        updateMetadata: (type, id, metadata) => dispatch(actions.updateMetadata(type, id, metadata)),
        addMemberToProject: (id, member) => dispatch(actions.addMemberToProject(id, member)),
        delMemberFromProject: (projectId, memberId) => dispatch(actions.delMemberFromProject(projectId, memberId)),
        loadUsers: () => dispatch(actions.userGetUsers())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Metadata);
